import { pagingSettings } from '../../../utils/GridPagingUtils';
import MyHoursListPageActionTypes from '../actions/my-hours-list-page-action-types';

const initialState = {
  loading: false,
  hours: null,
  summary: null,
  skip: pagingSettings.paging.skip,
  take: pagingSettings.paging.take,
  total: 0,
  sorting: null,
  cancelToken: null,
  isEnterCodeDialogVisible: false,
  submittingCode: false,
  enterCodeValidationResult: null,
  accessDeniedMessage: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MyHoursListPageActionTypes.LOAD_MY_HOURS_LIST_PAGE_START:
      return {
        ...state,
        loading: true
      };
    case MyHoursListPageActionTypes.LOAD_MY_HOURS_LIST_PAGE_END:
      return {
        ...state,
        loading: false,
        hours: action.payload?.hours ?? state.hours,
        summary: action.payload?.summary ?? state.summary,
        total: action.payload?.total ?? state.total,
        skip: action.payload?.skip ?? state.skip,
        take: action.payload?.take ?? state.take,
        accessDeniedMessage: action.payload?.accessDeniedMessage
      };
    case MyHoursListPageActionTypes.SORT_MY_HOURS_LIST:
      return {
        ...state,
        sorting: action.payload
      };
    case MyHoursListPageActionTypes.TOGGLE_ENTER_CODE_DIALOG:
      return {
        ...state,
        isEnterCodeDialogVisible: action.payload?.isVisible ?? false,
        submittingCode: false,
        enterCodeValidationResult: null
      };
    case MyHoursListPageActionTypes.SUBMIT_CODE_START:
      return {
        ...state,
        submittingCode: true,
        enterCodeValidationResult: null
      };
    case MyHoursListPageActionTypes.SUBMIT_CODE_END:
      return {
        ...state,
        submittingCode: false,
        alreadyRegistered: action.payload?.alreadyRegistered ?? false,
        enterCodeValidationResult: action.payload?.validationResult
      };
    default:
      return state;
  }
};
